// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import es6Promise from 'es6-promise'
// es6Promise.polyfill() // for IE 11
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex'
import VueAuth from '@websanova/vue-auth'
// import FlagIcon from 'vue-flag-icon'
import VeeValidate, {Validator} from 'vee-validate'
import 'babel-polyfill' // ES2015 polyfill

import router from './router'
import VuexStore from './vuex/store'

require('font-awesome-webpack')

// Init vue-auth
Vue.router = router // vue-auth router requires the router to be present here
Vue.use(VueAxios, axios)
Vue.use(VueAuth, {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  rolesVar: 'userrole_name'
})

Vue.config.productionTip = false
Vue.use(Vuex)
const store = new Vuex.Store(VuexStore)
// Vue.use(FlagIcon)
Vue.use(BootstrapVue)
Vue.use(VeeValidate, {errorBagName: 'veeErrors', fieldsBagName: 'veeFields', inject: false})

const alwaysOk = (value) => { return true }

// The messages getter may also accept a third parameter that includes the data we returned earlier.
Validator.extend('ok', {
  validate: alwaysOk,
  getMessage: () => { return 'ok' }
})
import App from './App'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js